import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import DownArrow from "../../../../../../src/assets/images/icons/down_arrow.svg";
import UpArrow from "../../../../../../src/assets/images/icons/up_arrow.svg";
import {
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../../../../helpers/global_helper";
import { useDispatch, useSelector } from "react-redux";
import { setTotalNoResult } from "../../../../../redux/actions";
import { formatPrice } from "../../../../NumberFormat";

const EventBonus = (props) => {

  const dispatch = useDispatch()
  const [eventBonusData, setEventBonusData] = useState([]);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [loading, setLoading] = useState(false)


  const pageNumber = useSelector((state) => state.paginationData.pageNumber)
  const perPage = useSelector((state) => state.paginationData.dataInOnePage)

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };
  const sortedData = () => {
    let dataArray = [];

    if (Array.isArray(eventBonusData)) {
      dataArray = eventBonusData; // Already an array, no conversion needed
    } else if (eventBonusData && typeof eventBonusData === "object") {
      dataArray = Object.values(eventBonusData); // Convert object values to an array
    } else {
      return []; // Return an empty array if eventBonusData is null, undefined, or invalid
    }

    if (sortBy === "date") {
      return dataArray.slice().sort((a, b) => {
        const aValue = new Date(a.date).getTime();
        const bValue = new Date(b.date).getTime();
        return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
      });
    } else if (sortBy === "tover" || sortBy === "amount") {
      return dataArray.slice().sort((a, b) => {
        const aValue = parseFloat(a[sortBy]);
        const bValue = parseFloat(b[sortBy]);
        return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
      });
    } else if (sortBy === "name" || sortBy === "game_name") {
      return dataArray.slice().sort((a, b) => {
        const aValue = a.name.toLowerCase();
        const bValue = b.name.toLowerCase();
        return sortOrder === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      });
    }
    return dataArray; // Default: no sorting applied
  };

  // api for Event Bonus list
  const fetchEventBonusList = () => {
    setLoading(true)

    let reqData = {
      // type: "bonus_event",
      page: pageNumber,
      length: perPage,
    };

    makeAjax(url.PLAYER_API.listEventBonus, reqData, url.PLAYER_MS_EXT).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code !== "validation_error") {
          showMessage(response);
          return;
        }
        showMessage(response);
        return;
      }
      setEventBonusData(response.data.data);
      dispatch(setTotalNoResult(response.data.total))
    });
    setLoading(false)
  };

  useEffect(() => {
    fetchEventBonusList();
  }, [perPage, sortBy, sortOrder, pageNumber]);

  // Helper function to map game_type to names
  const getGameTypeName = (event_id, for_game, $gameType) => {
    console.log("somnath testing ====>", event_id, for_game, $gameType);

    // Regex: match any number between 301–399 inside comma-separated list
    let match301to399 = /(^|,)(30[1-9]|3[1-8][0-9]|39[0-9])(,|$)/.test(for_game);
    // Special rule override
    if (event_id == 5 && $gameType == 3 && match301to399) {
      return 'Dingdong';
    }
    // Default mapping
    switch ($gameType) {
      case 3: return 'CardGame';
      case 2: return 'Dingdong';
      case 5: return 'Togel';
      default: return 'Unknown';
    }
  }

  return (
    <div className="turnover_popup">
      <div className="table_container">
        <table className="table_data">
          <thead>
            <tr>
              <th onClick={() => handleSort("date")}>
                {props.t("date")}
                <span className="sorting_arrow">
                  <img src={sortBy === "date" && sortOrder === "asc" ? UpArrow : DownArrow} alt="" />
                </span>
              </th>
              <th onClick={() => handleSort("name")}>
                {props.t("event")}
                <span className="sorting_arrow">
                  <img src={sortBy === "name" && sortOrder === "asc" ? UpArrow : DownArrow} alt="" />
                </span>

              </th>
              <th onClick={() => handleSort("game_name")}>
                {props.t("game")}
                <span className="sorting_arrow">
                  <img src={sortBy === "game_name" && sortOrder === "asc" ? UpArrow : DownArrow} alt="" />
                </span>
              </th>
              <th onClick={() => handleSort("tover")}>
                {props.t("turnover")}
                <span className="sorting_arrow">
                  <img src={sortBy === "tover" && sortOrder === "asc" ? UpArrow : DownArrow} alt="" />
                </span>
              </th>
              <th>{props.t("category")}</th>
              <th onClick={() => handleSort("amount")}>
                {props.t("bonus_amount")}
                <span className="sorting_arrow">
                  <img src={sortBy === "amount" && sortOrder === "asc" ? UpArrow : DownArrow} alt="" />
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {!loading &&
              (sortedData().length === 0 ? (
                <tr className="table_data_empty_row ">
                  <td colSpan="6">{props.t("data_not_found")}</td>
                </tr>
              ) :
                (
                  sortedData().map((item, index) => (
                    <tr
                      key={index}
                      className={index % 2 === 0 ? "first_bg" : "second_bg"}
                    >
                      <td>{item.date}</td>
                      <td>{item.name}</td>
                      <td>{item.game_name}</td>
                      <td>{formatPrice(item.tover)}</td>
                      <td>{getGameTypeName(item.event_id, item.for_game, item.game_type)}</td>
                      <td>{formatPrice(item.amount)}</td>
                    </tr>
                  ))
                ))
            }
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default withTranslation()(EventBonus);
